import { ACTIONS } from 'src/app/core/utils/actions.constants';
import { COMMONS } from 'src/app/core/utils/commons.constants';

export const SUBCATALOG_CONSTANTS = {
  id: 'admin.system.subcatalog',
  title: 'Administración: ',
  
  labels: {
    ...COMMONS,
    altCode: `${COMMONS.code} Alterno`,
    saveSuccess: 'El catálogo se guardó exitosamente!',
  },
  
  actions: {
    ...ACTIONS,
    add: `${ACTIONS.add} Catálogo`,
    edit: `${ACTIONS.edit} Catálogo`,
  }
};
